import SimpleSchema from "../simple";

const schema = {
  surveyDate: {
    type: Date,
    label: "Erhebungsdatum",
    defaultValue: function () {
      return new Date();
    },
    input: "DatePicker",
    group: "Allgemeine Erhebungsdaten",
  },
  name: {
    type: String,
    label: "Name",
    defaultValue: (props, state) => {
      return props.count + 1 + ". Wundbild";
    },
    group: "Allgemeine Erhebungsdaten",
  },
  note: {
    type: String,
    label: "Bemerkung",
    optional: true,
    input: "TextArea",
    group: "Allgemeine Erhebungsdaten",
  },
  imageFileId: {
    type: String,
    label: "Wundbild",
    input: "File",
    multiple: false,
    optional: true,
    group: "Wundbild",
    inputOptions: {
      hidelabel: true,
    },
  },
  imageMeasure: {
    type: Object,
    blackbox: true,
    label: "Messung",
    input: "ImageMeasure",
    optional: true,
    group: "Wundbild",
  },
  depth: {
    type: Number,
    label: "Wundtiefe in cm",
    input: "Number",
    optional: true,
    group: "Allgemeine Erhebungsdaten",
    defaultValue: () => {
      return 1;
    },
  },
  referenceLength: {
    type: Number,
    label: "Referenzlänge in cm",
    input: "Number",
    optional: true,
    max: 100,
    group: "Allgemeine Erhebungsdaten",
    defaultValue: function () {
      return 1;
    },
  },
  referenceLengthPath: {
    type: Array,
    listed: false,
    defaultValue: function () {
      return [];
    },
  },
  "referenceLengthPath.$": {
    type: Object,
    listed: false,
  },
  "referenceLengthPath.$.posX": {
    type: Number,
    label: "Position X",
    min: 0,
    max: 100,
    listed: false,
  },
  "referenceLengthPath.$.posY": {
    type: Number,
    label: "Position X",
    min: 0,
    max: 100,
    listed: false,
  },
  length: {
    type: String,
    label: "Länge in cm",
    optional: true,
    readonly: true,
    group: "Allgemeine Erhebungsdaten",
  },
  lengthPath: {
    type: Array,
    listed: false,
    defaultValue: function () {
      return [];
    },
  },
  "lengthPath.$": {
    type: Object,
    listed: false,
  },
  "lengthPath.$.posX": {
    type: Number,
    label: "Position X",
    min: 0,
    max: 100,
    listed: false,
  },
  "lengthPath.$.posY": {
    type: Number,
    label: "Position X",
    min: 0,
    max: 100,
    listed: false,
  },
  width: {
    type: String,
    label: "Breite in cm",
    optional: true,
    readonly: true,
    group: "Allgemeine Erhebungsdaten",
  },
  widthPath: {
    type: Array,
    listed: false,
    defaultValue: function () {
      return [];
    },
  },
  "widthPath.$": {
    type: Object,
    listed: false,
  },
  "widthPath.$.posX": {
    type: Number,
    label: "Position X",
    min: 0,
    max: 100,
    listed: false,
  },
  "widthPath.$.posY": {
    type: Number,
    label: "Position X",
    min: 0,
    max: 100,
    listed: false,
  },
  surface: {
    type: String,
    label: "Wundfläche in cm²",
    max: 50,
    optional: true,
    readonly: true,
    group: "Allgemeine Erhebungsdaten",
  },
  surfacePath: {
    type: Array,
    listed: false,
    defaultValue: function () {
      return [];
    },
  },
  "surfacePath.$": {
    type: Object,
    listed: false,
  },
  "surfacePath.$.posX": {
    type: Number,
    label: "Position X",
    min: 0,
    max: 100,
    listed: false,
  },
  "surfacePath.$.posY": {
    type: Number,
    label: "Position X",
    min: 0,
    max: 100,
    listed: false,
  },
  createdAt: {
    type: Date,
    label: "Date of creation",
    autoValue: function () {
      if (typeof Meteor !== "undefined" && this.isInsert) {
        return new Date();
      } else if (typeof Meteor !== "undefined" && this.isUpsert) {
        return new Date();
      } else if (typeof Meteor === "undefined") {
        return new Date();
      }
    },
    listed: false,
  },
  updatedAt: {
    type: Date,
    label: "Date of change",
    autoValue: function () {
      return new Date();
    },
    optional: true,
    listed: false,
  },
  patientId: {
    type: String,
    label: "PatientId",
    visible: "false",
    defaultValue: (props) => {
      return props.patientId;
    },
  },
  therapyId: {
    type: String,
    label: "TherapyId",
    visible: "false",
    defaultValue: (props) => {
      return props.therapyId;
    },
  },
  createdBy: {
    type: String,
    listed: false,
  },
  companyId: {
    type: String,
    listed: false,
  },
  canceled: {
    type: Boolean,
    label: "Canceled",
    optional: true,
    listed: false,
  },
  deleted: {
    type: Boolean,
    label: "deleted",
    optional: true,
    listed: false,
  },
};

const simpleSchema = new SimpleSchema(schema);
if (typeof Mongo !== "undefined") {
  WoundImages = new Mongo.Collection("woundImages");
  WoundImages.schema = simpleSchema;
  WoundImages.attachSchema(simpleSchema);
  WoundImages._ensureIndex({ therapyId: 1 });
  WoundImages._ensureIndex({ patientId: 1 });
  WoundImages._ensureIndex({ companyId: 1 });
}

export { simpleSchema as WoundImageSchema };

export default schema;
